import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Col, Row, Form, Button, Spinner } from "react-bootstrap";
import { GoArrowLeft } from "react-icons/go";
import { RxPencil1 } from "react-icons/rx";
import "../../../../src/TextFamily.css";
import "../PopUp.css";
import "../DeshBoard.css";
import { Api } from "../../../services/httpService";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { url, subscriptionKey } from "../../../constants";
import axios from "axios";
import UploadDoc from "../../../assests/upload.png";
import Loader from "../LoaderModal";

function ProductDetailsModal({
  selectedProduct,
  logoIcon,
  show,
  setShow,
  buyer,
  setBuyer,
  productBrand,
  setProductBrand,
  merchantId,
  setSelectedProduct
}) {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState(false);
  const [allValid, setAllValid] = useState(false);
  const [productFieldList, setProductFieldList] = useState([]);
  const [loading, setLoading] = useState(true);


  const tokenHeader = localStorage.getItem("_token") || "";

  let initialFormState = {};


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Api(
          "get",
          `/product/buyer_data_fields?buyerPlatFormId=${selectedProduct?.id}&merchantId=${merchantId}`
        );
        if (response && response.body) {
          setProductFieldList(response.body);
          if (response?.body.length > 0) {
            response?.body?.forEach((element) => {
              if (element?.paramType == "FIELD") {
                initialFormState[element?.identifier] = element?.value
                  ? element?.value
                  : "";
              }
            });
            setFormData(initialFormState);
          }
        } else {
          console.warn("No Buyer field found in response.");
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedProduct?.id]);


  /* ---------- Handlers ---------- */
  const handleClose = () => {
    setFormData(initialFormState);
    setTouched(false);
    setErrors({});
    setShow(false);
    setSelectedProduct(null)
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (productFieldList.length > 0) {
      let newErrors = {};

      productFieldList.forEach((f) => {
        const value = formData[f.identifier]
         

        if (f.isMandatory && !value) {
          newErrors[f.identifier] = `${f.title} is required`;
        }

        // Email validation
        if (
          f.paramType === "FIELD" &&
          f.identifier.toLowerCase() === "email" &&
          value &&
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ) {
          newErrors[f.identifier] = "Invalid email format";
        }
      });

      setErrors(newErrors);
      setAllValid(Object.keys(newErrors).length === 0);
    }
  }, [formData, productFieldList]);

  const saveBuyerPlatform = async (buyerId) => {
    buyerId = buyerId.toString();
    try {
      setLoading(true);
      const result = await axios({
        method: "put",
        url:
          url +
          "/merchantBuyerPlatforms" +
          "?bp_id=" +
          buyerId +
          "&m_id=" +
          merchantId,
        headers: {
          "Ocp-Apim-Subscription-Key": subscriptionKey,
          Authorization: tokenHeader,
        },
      });
      if (result?.data && result?.data?.success) {
        return true;
      } else {
        setLoading(false);
        return false;
      }
    } catch (err) {
      setLoading(false);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setTouched(true);

      if (!allValid) {
        console.warn("Form is invalid, fix errors first.");
        return;
      }

      setLoading(true);

      let saved = await saveBuyerPlatform(selectedProduct?.id);
      if (saved) {
        // Construct API request body
        const paramFieldData = productFieldList.map((field) => ({
          paramId: field.id,
          buyerPlatFormId: selectedProduct?.id,
          merchantId: merchantId,
          value: formData[field.identifier] || "",
        }));

        const response = await Api(
          "post",
          `/product/insert_buyer_data_fields`,
          {
            paramFieldData,
          }
        );


        if (response.success && response.body) {
          setLoading(false);
          handleClose();
          setProductBrand(false);
          setBuyer(null);
        } else {
          setLoading(false);
        }
      } 
    } catch (err) {
      console.log("Error submitting bank details:", err);
      setLoading(false);
    }
  };


  /* ---------- Render ---------- */
  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="company-add-popup financing-solution-popup"
        centered
      >
        <Modal.Header className="d-flex py-4 px-4">
          <div className="arrow-btn " onClick={handleClose}>
            <GoArrowLeft />
          </div>
          {logoIcon && (
            <div className="p-img-box rounded-circle overflow-hidden d-flex align-items-center justify-content-center mx-3">
              <img
                className="rounded-circle"
                src={logoIcon}
                alt={selectedProduct?.name}
              />
            </div>
          )}
          <div className="modal-title-detail">
            <h3 className="title-brand">{selectedProduct?.name}</h3>
            <p className="brand-name mb-0">{buyer?.typeName}</p>
          </div>
          {/* Buyer Note */}
        </Modal.Header>

        <Form onSubmit={handleSubmit}>
          <Modal.Body className="modal-full-text p-4">
            <div className="buyer-note mb-4">
              <div className="buyer-note-centent d-flex p-3 align-items-start">
                <span>
                  <AiOutlineInfoCircle />
                </span>
                <p className="m-0">
                  If you do business with multiple buyers, start with the
                  largest one. You can always add new buyer platforms later.
                </p>
              </div>
            </div>
            <div className="financing-solution-form">
              <div className="finnanc-form-title">
                Provide Buyer Portal Access
              </div>
              {loading ? (
                <Loader/>
              ) : (
                <div className="f-solution-form-inner p-3">
                  {productFieldList.length > 0 &&
                    productFieldList.map((product, index) => {
                      const inputType =
                        product.identifier.toLowerCase() === "password"
                          ? "password"
                          : product.identifier.toLowerCase() === "email"
                          ? "email"
                          : "text";

                      return (
                        <div>
                          {product?.paramType == "FIELD" && (
                            <Row>
                              <Form.Group as={Col} md="12" className="mb-4">
                                <Form.Label>{product?.title}</Form.Label>
                                <Form.Control
                                  required={product?.isMandatory}
                                  type={inputType}
                                  // placeholder={product?.title}
                                  name={product?.identifier}
                                  value={formData[product.identifier]}
                                  onChange={handleChange}
                                  disabled={!product?.isEnabled}
                                  isInvalid={
                                    touched && !!errors[product.identifier]
                                  }
                                />
                                <span className="note">
                                  {product?.description}
                                </span>

                                <Form.Control.Feedback type="invalid">
                                  {errors[product.identifier] ||
                                    `${product?.title} is required`}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Row>
                          )}

                          
                          {/* linkTextField */}
                          {/* <Form.Group
                          as={Col}
                          md="12"
                          className="mb-4 position-relative edit-icon"
                        >
                          <Form.Label>Home</Form.Label>
                          <Form.Control
                            required={product?.isMandatory}
                            type={inputType}
                            placeholder={product?.description}
                            name={product?.identifier}
                            value={formData[product.identifier] || ""}
                            onChange={handleChange}
                            disabled={!product?.isEnabled}
                            isInvalid={touched && !!errors[product.identifier]}
                          />
                          <span className="position-absolute ">
                            <RxPencil1 />
                          </span>
                        </Form.Group> */}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer className="p-3 active">
            <Button
              className="d-flex align-items-center"
              variant={allValid ? "primary active" : "primary"}
              type="submit"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default ProductDetailsModal;
